export default {
  // 标题
  waylineLibrary: '航线库',
  downloading: '下载中',

  // 工具提示
  waylinePlanning: '航线规划',
  refreshWaylineList: '刷新航线列表',
  importKmzWaylineFile: '导入 KMZ 航线文件',
  aiAlgorithm: '遥控器AI算法',
  aiAlgorithmSwitch: '遥控器 AI 算法开关',

  // 航线类型
  waypoint: '航点',
  planar: '正射',
  oblique: '倾斜',

  // 菜单项
  bindAlgorithm: '绑定算法',
  copyWayline: '复制航线',
  download: '下载',
  edit: '编辑',
  delete: '删除',

  // 标签
  updateTime: '更新时间',

  // 删除确认对话框
  deleteWaylineConfirmTitle: '删除后航线内容将不可恢复，您确定要删除该航线吗？',
  deleteWaylineConfirmOk: '确定',
  deleteWaylineConfirmCancel: '取消',

  // 算法模型对话框
  algorithmModelAdd: '算法模型添加',
  addModel: '添加模型',
  skipFrameCount: '跳帧数量',
  frame: '帧',
  pushFrequency: '推送频率',
  second: '秒',
  confidence: '置信度',
  modelName: '模型名称：',
  startWaypoint: '开始算法航点',
  endWaypoint: '结束算法航点',
  cancel: '取消',
  confirm: '确定',

  // 提示消息
  waylineFileNotFound: '未找到可复制的航线文件',
  copyWaylineSuccess: '复制航线成功',
  deleteSuccess: '删除成功',
  aiToggleSuccess: '{action}成功',
  aiOpen: '开启',
  aiClose: '关闭',
  notFoundWayline: '未找到该航线',
  fileUploadSuccess: '{fileName} 文件上传成功',
  bindingAlgorithmSuccess: '绑定算法成功',

  // 其他
  createWaylineInDJIWeb: '在 DJI 网页端创建航线（新窗口打开）',
  djiWebUrl: 'https://fh.dji.com/organization/fe22e2f5-3296-417c-bcfa-5cdc8b0503f6/project/561bd128-79c0-44b2-ae94-e56c8388b268#/wayline/create',

  // 航线规划页 waylinePlan.vue
  plan: {
    back: '返回',
    saveWayline: '保存航线',
    waylineSettings: '航线设置',
    restoreDefaultView: '恢复默认视角',
    newWayline: '新建航线',
    newWaylineName: '新建航线',
    waylineName: '航线名称',
    enterWaylineName: '请输入航线名称',
    deviceType: '设备类型',
    photoSettings: '拍照设置',
    widePhoto: '广角照片',
    zoomPhoto: '变焦照片',
    irPhoto: '红外照片',
    verticalClimb: '垂直爬升',
    obliqueClimbNotRecommended: '倾斜爬升(不推荐)',
    heightMode: '航线高度模式',
    altitudeHeight: '海拔高度',
    relativeTakeoffHeight: '相对起飞点高度',
    relativeTerrainHeight: '相对地形高度',
    globalWaylineSpeed: '全局航线速度',
    advancedSettings: '高级设置',
    waypointType: '航点类型',
    turnStraightStop: '直线飞行，飞行器到点停',
    turnCoordinate: '协调转弯，不过点，提前转弯',
    turnCurveStop: '曲线飞行，飞行器到点停',
    turnCurvePass: '曲线飞行，飞行器过点不停',
    aircraftHeadingMode: '飞行器偏航角模式',
    headingFollowWayline: '沿航线方向',
    headingFixed: '锁定当前偏航角',
    gimbalPitchControlMode: '航点间云台俯仰角控制模式',
    gimbalManual: '手动控制',
    gimbalUsePointSetting: '依照每个航点设置',
    finishAction: '完成动作',
    finishGoHome: '自动返航',
    finishNoAction: '退出航线模式',
    finishAutoLand: '原地降落',
    finishGotoFirstWaypoint: '返回航线起始点悬停',
    waypointList: '航点列表',
    routeLength: '航线\n长度',
    estimatedTime: '预计执行\n时间',
    waypointCount: '航点',
    photos: '照片',
    waypointIndex: '航点{n}',
    deleteWaypoint: '删除航点',
    deleteAction: '删除动作',
    addWaypoint: '新建航点',
    leftClickAddTooltip: '左键新增航点，右键结束绘制',
    longitude: '经度',
    latitude: '纬度',
    height: '高度',
    enterLongitude: '请输入经度',
    enterLatitude: '请输入纬度',
    enterHeight: '请输入高度',
    zoom: '变焦',
    startRecord: '开始录像',
    stopRecord: '结束录像',
    hover: '悬停',
    takePhoto: '拍照',
    aircraftYaw: '飞行器偏航角',
    gimbalPitch: '云台俯仰角',
    panoShot: '全景拍照',
    cameraZoom: '相机变焦',
    selectTakeoffFirst: '请先选择起飞点',
    hoverMax900: '悬停时间最多900s',
    hoverMin1: '悬停时间最少1s',
    heightMax1500: '高度不能超过1500m',
    heightMin10: '高度不能低于10m',
    maxSpeedReached: '已到最大速度',
    minSpeedReached: '已到最小速度',
    resetView: '重置视图',
    zoomIn: '放大',
    zoomOut: '缩小',
  },
}